import React from 'react'

class RtOvwLegend extends React.Component {
    constructor(props) {
        super(props);
        this.state={visible:true};
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(evt) {
        console.log("CLicked")
        this.setState({visible:!this.state.visible});
    }
    render() {
        const visible = this.state.visible;

        const colors = !visible ? null : (
                <div className="rt-ovw__legend-items">
                    <div className="rt-ovw__legend-subtitle">View Colors</div>
                    <div className="rt-ovw__legend-item--awaiting">Awaiting Retouch</div>
                    <div className="rt-ovw__legend-item--checked-out">Retouch in Progress</div>
                    <div className="rt-ovw__legend-item--completed">Awaiting QC</div>
                    <div className="rt-ovw__legend-item--recalled">Recalled</div>
                    <div className="rt-ovw__legend-item--rejected">Rejected</div>
                    <div className="rt-ovw__legend-item--approved">Approved</div>
                    <div className="rt-ovw__legend-item--prepro-checked-out">Prepro Checked Out</div>
                    <div className="rt-ovw__legend-subtitle">Urgency Colors</div>
                    <div className="rt-ovw__legend-item rt-ovw--urgency-late">Late</div>
                    <div className="rt-ovw__legend-item rt-ovw--urgency-urgent">Urgent</div>
                    <div className="rt-ovw__legend-item rt-ovw--urgency-medium">Medium</div>
                    <div className="rt-ovw__legend-item rt-ovw--urgency-lite">Lite</div>
                    <div className="rt-ovw__legend-item rt-ovw--urgency-missing">Unknown</div>
                </div>

            )
        return (
            <div className="rt-ovw__legend" onClick={this.handleClick}>
                {!visible?(<div className="rt-ovw__legend-title">Colors</div>):colors}
            </div>
        )

    }
}

export default RtOvwLegend;


// WEBPACK FOOTER //
// ./src/ui/components/RtOvwLegend.js